
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/products/[slug]",
      function () {
        return require("private-next-pages/community/products/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/products/[slug]"])
      });
    }
  